// Logica pura del carrello: confezione regalo e stima spedizione. Niente DOM.
// Caricata dal browser (window.GhirigoroCartLogic) e da node --test (CommonJS).
(function (radice) {
  var PROP = 'Confezione regalo';

  function donata(riga) {
    return !!(riga.properties && riga.properties.Scuola);
  }

  function giftWrapPlan(cart, wrapVariantId) {
    var items = (cart && cart.items) || [];
    var wrap = null;      // prima riga confezione
    var extra = [];       // eventuali altre righe confezione (es. aggiunta a mano dalla sua scheda)
    var presenti = 0;     // somma di TUTTE le righe confezione
    var target = 0;
    items.forEach(function (riga) {
      if (wrapVariantId != null && Number(riga.variant_id) === Number(wrapVariantId)) {
        if (wrap) extra.push(riga.key); else wrap = riga;
        presenti += riga.quantity;
        return;
      }
      if (donata(riga)) return;
      if (riga.properties && riga.properties[PROP] === 'Sì') target += riga.quantity;
    });
    if (wrap) {
      var piano;
      if (target === 0) piano = { action: 'remove', quantity: 0, key: wrap.key };
      else if (presenti !== target || extra.length) piano = { action: 'set', quantity: target, key: wrap.key };
      else return { action: 'none', quantity: target };
      if (extra.length) piano.extraKeys = extra; // da azzerare: la quantità giusta sta sulla prima riga
      return piano;
    }
    if (target > 0 && wrapVariantId != null) return { action: 'add', quantity: target };
    return { action: 'none', quantity: 0 };
  }

  // Un libro donato si ritira in negozio e l'ordine ha un solo metodo di consegna: se ce n'è uno, si ritira tutto.
  function shippingEstimate(cart, opzioni) {
    var costoCents = Math.round(opzioni.costo * 100);
    var sogliaCents = Math.round(opzioni.soglia * 100);
    var items = (cart && cart.items) || [];
    if (items.some(donata)) return { stato: 'ritiro', costoCents: 0, mancanoCents: 0 };
    // I buoni regalo (requires_shipping false) non si spediscono e non contano per la soglia
    var daSpedire = items.filter(function (riga) { return riga.requires_shipping !== false; });
    if (daSpedire.length === 0 && items.length > 0) return { stato: 'digitale', costoCents: 0, mancanoCents: 0 };
    var base = 0;
    daSpedire.forEach(function (riga) { base += riga.final_line_price; });
    if (base >= sogliaCents) return { stato: 'gratis', costoCents: 0, mancanoCents: 0 };
    return { stato: 'costo', costoCents: costoCents, mancanoCents: sogliaCents - base };
  }

  // Pezzi mostrati nel badge del carrello: tutto tranne le righe confezione regalo.
  function pezziCarrello(cart, wrapVariantId) {
    var n = 0;
    ((cart && cart.items) || []).forEach(function (riga) {
      if (wrapVariantId != null && Number(riga.variant_id) === Number(wrapVariantId)) return;
      n += riga.quantity;
    });
    return n;
  }

  var api = { giftWrapPlan: giftWrapPlan, shippingEstimate: shippingEstimate, pezziCarrello: pezziCarrello, PROP: PROP };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else radice.GhirigoroCartLogic = api;
})(typeof window !== 'undefined' ? window : this);
